<template>
  <v-container>
    <v-form ref="formStep2" v-model="valid" class="mt-2">
      <v-layout justify-space-between wrap>
        <v-flex md5 xs12>
          <v-row>
            <v-col>
              <h3>
                {{ titleWhat }}
                <span class="primary--text">*</span>
              </h3>
            </v-col>
          </v-row>
          <WhatField
            placeholder="חפש תפקיד"
            @whatSearch="updateWhatField"
            @deleteWhat="deleteWhatJD"
            :keywordJD="smartAgentFirstStepCat"
          />
        </v-flex>

        <v-flex md5 xs12>
          <v-row>
            <v-col>
              <h3>
                {{ titleWhere }}
                <span class="primary--text">*</span>
              </h3>
            </v-col>
          </v-row>
          <LocationWithRange
            :isRounded="true"
            :placeholder="'מיקום'"
            @distanceSelected="updateDistanceSelection"
            @updateLocation="updateSuggestedLocation"
            @deleteLocation="deleteLocationA"
          />
        </v-flex>
      </v-layout>

      <v-flex xs12 sm12 md12 text-center mt-2 class="flex-basis-auto">
        <v-layout mt-12 mb-12>
          <v-flex text-center mt-ms-12>
            <v-btn
              color="primary"
              :disabled="!validateWhere() || !whatSearchJD"
              class="display-18"
              rounded
              @click="subscribeToSmartAgent"
              :loading="isLoading"
            >
              {{ forwardToJobs }}
            </v-btn>
            <small class="red--text text-center d-block py-2 font-weight-medium">
              {{ error }}
            </small>
          </v-flex>
        </v-layout>
        <v-flex text-center>
          <p class="display-18 mt-12 mt-md-0">
            <span class="display-20 font-weight-medium">{{ didYouKnow }}</span>
            {{ defineMore }}
            <a
              href="https://www.drushim.co.il/personal/myboard.aspx"
              class="black--text"
            >
              באזור האישי
            </a>
          </p>
        </v-flex>

        <v-dialog v-model="dialog" max-width="320" persistent>
          <v-card>
            <v-card-text class="display-22" color="primary" text-center>
              {{ successMsg }}
            </v-card-text>

            <v-card-actions>
              <v-spacer />

              <v-btn color="green darken-1" text @click="closeDialog">
                {{ closeTxt }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-form>

    <v-dialog v-model="alertAgent" width="500">
      <v-card class="py-3">
        <v-row>
          <v-col class="pb-0">
            <p class="text-center mt-3 mb-2">
              סוכן חכם זה כבר קיים. יש לשנות הגדרות חיפוש
            </p>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-center">
            <v-btn
              color="primary"
              class="px-5"
              height="35"
              width="100"
              large
              rounded
              @click="alertAgent = false"
            >
              סגור
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { t } from '@/store/modules/homeDrushim/constantsContent';
import gtm from '@/lib/gtm';
import LocationWithRange from '@/components/Forms/Form_Fields/LocationWithRange.vue';
import WhatField from '@/components/Forms/Form_Fields/WhatField.vue';
import { REGISTER_SMART_ALERTS } from '@/lib/api.js';

export default {
  components: {
    LocationWithRange,
    WhatField,
  },

  data() {
    return {
      titleWhat: 'בחירת תפקיד',
      titleWhere: 'איפה העבודה הבאה שלך?',
      forwardToJobs: t('titles.smartAgent.forwardToJobs'),
      didYouKnow: t('titles.smartAgent.didYouKnow'),
      defineMore: t('titles.smartAgent.defineMore'),
      successMsg: t('titles.smartAgent.successMsg'),
      closeTxt: t('titles.closeTxt'),
      dialog: false,
      isLoading: false,
      valid: false,

      whatSearchJD: '',
      error: null,
      alertAgent: false,

      autoSuggestModelA: null,
      distanceModelA: { Code: 3, NameInHebrew: '30 ק"מ' },
      openMore: false,
    };
  },

  mounted() {
    // this.$nuxt.$on('chosenCat', this.chosenCatFun);
  },

  computed: {
    ...mapGetters(['smartAgentFirstStepCat']),
    ...mapState({
      categoryFromStep1: (state) => state.authUser.smartAgent.firstStepCategory,
    }),
  },

  methods: {
    ...mapActions(['addStepOneCategory']),
    updateDistanceSelection(value) {
      this.distanceModelA = value;
    },

    updateSuggestedLocation(value) {
      this.autoSuggestModelA = value;
    },

    deleteLocationA() {
      this.autoSuggestModelA = null;
    },

    updateWhatField(value) {
      this.whatSearchJD = value.trim();
    },

    deleteWhatJD() {
      this.whatSearchJD = '';
    },

    validateWhere() {
      if (
        this.autoSuggestModelA &&
        this.autoSuggestModelA.NameInHebrew &&
        this.autoSuggestModelA.Code
      ) {
        return true;
      } else {
        this.autoSuggestModelA = null;
        return false;
      }
    },

    validateWhat(whatSearch){
      return whatSearch.trim();
    },

    closeDialog() {
      this.dialog = false;
      window.location = 'https://www.drushim.co.il/personal/myboard.aspx';
    },
    async subscribeToSmartAgent() {
      this.$nuxt.$loading.start();
      this.isLoading = true;
      let locationA = this.autoSuggestModelA?.GeoLexId;
      let distanceA = this.distanceModelA.Code;
      let Categories = {};

      let Locations = locationA
        ? {
            [locationA]: distanceA,
            // ...(locationB && { [locationB]: distanceB })
          }
        : {};

      let Keywords = this.whatSearchJD ? [this.whatSearchJD] : [];

      let currentQueryParams =
        this.$route.fullPath.indexOf('?') > -1
          ? this.$route.fullPath.split('?')[1]
          : false;

      currentQueryParams = currentQueryParams ? `?${currentQueryParams}` : '';

      const data = {
        Locations,
        Categories,
        Keywords,
      };

      try {
        await this.$axios
          .post(`${REGISTER_SMART_ALERTS}/${currentQueryParams}`, data)
          .then((res) => {
            gtm({
              page: '/smartalerts/step3/complete',
              event: 'smartalert',
            });

            gtm({
              category: 'שליחת סוכן חכם',
              event: 'smart_agent_submit',
            });

            if (res.data.IsError) {
              throw res.data.Errors;
            }

            this.fetchUser().then(() => {
              this.$router.push('/personal/smartalertsnotification/');
              this.$nuxt.$loading.start();
            });
          });
      } catch (e) {
        this.$nuxt.$loading.finish();
        this.isLoading = false;
        let err = Object.keys(e).toString();
        if (err === 'MustChooseSubCategory') {
          this.error = 'יש לבחור תחומים ';
        } else if (err === 'DuplicateAgent') {
          this.alertAgent = true;
        } else {
          this.error = 'שגיאת רישום';
        }
        console.log(e);
      }
    },
    async fetchUser() {
      await this.$auth.fetchUser();
    },
  },
};
</script>

<style lang="scss" scoped>
div.v-input__slot {
  border-radius: 50px;
  border-color: red;
}

#area-select {
  flex-wrap: wrap;
}

.expand {
  cursor: pointer;
}

.v-autocomplete:not(.v-input--is-disabled).v-select.v-text-field input {
  color: $primary !important;
}
@media screen and (min-width: 600px) {
  #area-select {
    flex-wrap: nowrap;
  }

  .areas-wrapper {
    margin-top: 0;
  }
}
</style>
